import { Link, ModuleBase, ResponsiveImage, PopoverMenu, PopoverMenuMethods } from '@/components';
import { CategoryModel, ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import Flicking from '@egjs/react-flicking';
import classNames from 'classnames';
import { useRef } from 'react';
import { usePathname } from 'next/navigation';

type InnovationPlatformsNavigationModel = ModuleBaseModel<
  {
    innovationPlatforms: CategoryModel[];
  } & ModuleBasePropsModel
>;

const InnovationPlatformsNavigation = (data: InnovationPlatformsNavigationModel) => {
  const { innovationPlatforms } = data.props;
  const pathname = usePathname();
  const popoverMenuRef = useRef<PopoverMenuMethods>(null);

  if (innovationPlatforms.length === 0) {
    return null;
  }

  const activePlatform = innovationPlatforms.find((platform) => pathname === platform.landingPageLink.href);

  return (
    <ModuleBase data={data} noPadding className="py-1">
      <div data-lenis-prevent className="flex gap-6 py-3">
        <Flicking
          preventClickOnDrag
          preventDefaultOnDrag
          align="center"
          horizontal
          bound
          bounce={0}
          className="mx-2 hidden w-full md:block xl:mx-0"
          autoResize
          resizeOnContentsReady
        >
          {innovationPlatforms.map((platform, index) => (
            <Link
              key={index}
              link={platform.landingPageLink}
              className={classNames(
                'btn secondary btn-from-bg mx-2 flex items-center gap-3 py-2.5 !pr-7 !pl-6 first:ml-0 last:mr-0',
                pathname === platform.landingPageLink.href && 'bg-[#ebebeb]',
              )}
            >
              <div className="aspect-square w-[15px]">
                {platform.icon && <ResponsiveImage image={platform.icon} widths={{ xs: 15 }} heights={{ xs: 15 }} />}
              </div>
              <span className="font-normal tracking-normal whitespace-nowrap">{platform.landingPageLink.text}</span>
            </Link>
          ))}
        </Flicking>

        <PopoverMenu
          ref={popoverMenuRef}
          title={`<div class="flex items-center gap-3 text-base"><img src="${activePlatform?.icon?.imageUrl}?anchor=center&mode=crop&rnd=133033153486400000&width=15&height=15" class="aspect-square w-[15px]" /><span>${activePlatform?.landingPageLink.text}</span></div>`}
          className={classNames(
            'mx-3 min-w-[260px] md:hidden',
            '[&_.main-button]:h-10 [&_.main-button]:rounded-4xl [&_.main-button]:border [&_.main-button]:border-black/10 [&_.main-button]:!bg-[#53b7ad] [&_.main-button]:px-4 [&_.main-button]:text-white [&.open_.main-button]:bg-white',
            '[&_.arrow_svg]:fill-white',
            '[&_.content]:w-full [&_.content]:rounded-3xl [&_.content]:border [&_.content]:border-black/10 [&_.content]:py-2 [&_.content]:shadow-lg',
            '[&_.content-wrapper]:w-full',
          )}
          titleClass="text-sm font-medium"
          offset={10}
          placement="bottom-start"
        >
          {innovationPlatforms.map((platform, index) => (
            <Link
              key={index}
              link={platform.landingPageLink}
              className={classNames(
                'btn flex w-full !justify-start !gap-4 !rounded-none !py-[9px] !pr-4 !pl-4',
                pathname === platform.landingPageLink.href && 'bg-[#e9e3e3]',
              )}
              onClick={() => popoverMenuRef.current?.close()}
            >
              <div className="aspect-square w-[15px]">
                {platform.icon && <ResponsiveImage image={platform.icon} widths={{ xs: 15 }} heights={{ xs: 15 }} />}
              </div>
              <span className="font-normal whitespace-nowrap">{platform.landingPageLink.text}</span>
            </Link>
          ))}
        </PopoverMenu>
      </div>
    </ModuleBase>
  );
};

export default InnovationPlatformsNavigation;
